// src/features/ui/uiSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type UITheme = 'light' | 'dark';

export type UIState = {
    theme: UITheme;

};

const initialState: UIState = {
    theme: 'dark',
};

export const uiSlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        setTheme(state, action: PayloadAction<UITheme>) {
            state.theme = action.payload;
        },
    },
});

export const { setTheme } = uiSlice.actions;
export const uiReducer = uiSlice.reducer;
